import { render, staticRenderFns } from "./CategoryCardCanonical.vue?vue&type=template&id=6f18b86d&scoped=true"
import script from "./CategoryCardCanonical.vue?vue&type=script&lang=ts"
export * from "./CategoryCardCanonical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18b86d",
  null
  
)

export default component.exports